import React from 'react';
import './style.scss';

// TODO(dias): this interface is smaller
// than what's in the app.
interface TextProps {
    isReplyMessage?: boolean;
    message?: string;
}

const TextMessage = (props: TextProps) => {
    const { isReplyMessage, message } = props;

    return (
        <div className={`text-message ${isReplyMessage ? 'reply' : ''}`}>
            <p>{message}</p>
        </div>
    );
};

export default TextMessage;
